<template>
  <div>
    <div class="box">
      <div class="title">
        <span>当前人工客服繁忙，您已进入排队</span>
        <div style="margin-left: 4px;">
          <img :src="imgObj['1']" alt="" />
          <img :src="imgObj['3']" alt="" style="margin-left: 4px;" />
          <img :src="imgObj['2']" alt="" style="margin-left: 4px;" />
        </div>
      </div>
      <div class="content">
        <span style="color: #666">{{ getContent(message.content)[0] }}</span>
        <span style="color: #09ABEC" class="queneNum">{{
          getContent(message.content)[1]
        }}</span>
        <span style="color: #666">{{ getContent(message.content)[2] }}</span>
      </div>
      <a
        class="out_queue"
        :href="getContent(message.content)[3]"
        @click.prevent="outQuene($event)"
        >取消排队</a
      >
    </div>
  </div>
</template>

<script>
import request from '@/utils/common_req'
import { mapState } from 'vuex'

export default {
  name: 'waitingElement',
  props: {
    message: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      imgObj: {
        '1': require('@/assets/image/c1.png'),
        '2': require('@/assets/image/c2.png'),
        '3': require('@/assets/image/c3.png'),
      },
    }
  },
  mounted() {
    let historyNum = localStorage.getItem(
      `fb_waiting_${this.message.sessionId}`
    )
    if (historyNum) {
      let index = this.currentMessageList.findIndex(
        (i) =>
          i.sessionId == this.message.sessionId &&
          i.content.indexOf('out_queue') > -1
      )
      let outQueneUrl = this.currentMessageList[index].content.split('"')[3]
      this.currentMessageList[
        index
      ].content = `请耐心等待，前面还有*${historyNum}*位用户在排队 <a class="out_queue" href="${outQueneUrl}" onclick="return false">退出排队</a>`
    }
  },
  methods: {
    getContent(txt) {
      const items = txt.split('*')
      return [
        items[0],
        items[1],
        items[2].split('<a')[0].trim(),
        txt.split('"')[3],
      ]
    },
    outQuene(e) {
      let target = e.target
      request({
        url: target.href,
        method: 'GET',
      }).then((res) => {
        if (res.ret == 200 && !res.data) {
          this.$message({
            showClose: true,
            message: '此排队信息已过期',
            type: 'warn',
          })
        }
      })
    },
  },
  computed: {
    ...mapState({
      currentMessageList: (state) => state.conversation.currentMessageList,
    }),
  },
}
</script>

<style scoped>
.box {
  margin: 0 auto;
  width: 328px;
  height: 160px;
  background-color: #fff;
  border-radius: 8px;
  background-image: linear-gradient(
    0deg,
    rgba(0, 172, 235, 0) 14%,
    rgba(0, 172, 235, 0.16) 100%
  );
  /* transform: translateX(50%); */
  display: flex;
  flex-direction: column;
  align-items: center;
}

.box .title {
  font-size: 14px;
  color: #333333;
  text-align: right;
  font-weight: 500;
  margin-top: 28px;
  margin-bottom: 20px;
  display: flex;
}

.box .title img {
}

.box .content {
  margin-bottom: 9px;
}

.out_queue {
  width: 250px;
  height: 28px;
  background-color: #00aceb;
  border-radius: 4px;
  line-height: 28px;
  text-align: center;
  color: #fff;
  cursor: pointer;
  margin: 19px 0;
  text-decoration: none;
}

.remove_out_queue {
  width: 250px;
  height: 28px;
  border-radius: 4px;
  line-height: 28px;
  text-align: center;
  color: #fff;
  cursor: pointer;
  margin: 19px 0;
  background-color: grey;
  pointer-events: none;
}
</style>
